import React from 'react';
import { Container , Row, Col } from 'react-bootstrap';
import PageHero from '../Components/PageHero';

function Tuinplanten() {
    document.title = "Tuinplanten - Tuincentrum Boers B.V";

    return (
        <>
        <PageHero image={"./tuincentrum-voorkant.jpg"} imageAlt="Tuinplanten" />
        <Container>
        <div className="page-content">
                <Row>
                    <Col xs={12} md={6}>
                        <img src="./img/assortiment/tuinplanten.jpg" />
                    </Col>
                    <Col xs={12} md={6}>
                        <p>
                            Onze tuinplantenafdeling biedt een keur aan vaste planten, bomen, heesters enz. Ook in klimplanten hebben we een ruime sortering. Tijdens het moestuinseizoen kunt u bij ons terecht voor uw groenteplanten, pootaardappels enz. enz. In het voorjaar heel veel keuze in eenjarigen en kuipplanten.
                            <br/><br/>
                            Een groot gedeelte van onze tuinplantenafdeling is overdekt, zodat u in elk jaargetijde heerlijk droog en beschut kunt genieten van onze ruime sortering tuinplanten.
                        </p>
                    </Col>
                </Row>
            </div>
        </Container>
        </>
    )
}

export default Tuinplanten;